import { AsgardCommandBase } from '../command-base';
import { AsgardDocHtml } from 'src/app/core/documents/asgard-doc-html';

export class HTMLDocumentChangedCommand extends AsgardCommandBase {
    private currentElOffset: number | null = null;
    private value: string | null= null;
    constructor(
        public doc: AsgardDocHtml,
        private evt?: KeyboardEvent,
        private offset?: number
    ) {
        super(doc);
        if (this.evt && this.evt.keyCode === 13) {
            this.value = '\n';
        } else if(this.evt && this.evt.key){
            this.value = this.evt.key;
        }
        this.currentElOffset = this.offset || null;
    }

    async execute() {
        if(this.currentElOffset !== null && this.value !== null){
            this.doc.redoSymbol(this.currentElOffset, this.value);
        }
    }

    async undo() {
        if(this.currentElOffset !== null){
            this.doc.undoSymbol(this.currentElOffset);
        }
    }

}
